import { useEffect, useState } from 'react'
import { defineQuery } from 'groq'
import { getClient } from '../client'
import { DEFAULT_LANG } from '@autoplan/common'
import { useLang } from '../i18n/LocaleProvider'
import { useLiveVersion } from './useLiveVersion'
import type { NEWS_ARTICLES_QUERY_RESULT } from '../sanity.types'

export type NewsArticleSummary = NEWS_ARTICLES_QUERY_RESULT[number]

const NEWS_ARTICLES_QUERY = defineQuery(`*[_type == "newsArticle" && language == $lang] | order(publishedAt desc) {
  _id, title, slug, image, publishedAt, body
}`)

export function useNewsArticles() {
  const [articles, setArticles] = useState<NewsArticleSummary[]>([])
  const lang = useLang()

  const live = useLiveVersion()

  useEffect(() => {
    let active = true
    getClient()
      .fetch(NEWS_ARTICLES_QUERY, { lang })
      .then((result) =>
        result.length > 0 || lang === DEFAULT_LANG
          ? result
          : getClient().fetch(NEWS_ARTICLES_QUERY, { lang: DEFAULT_LANG }),
      )
      .then((result) => active && setArticles(result))

    return () => {
      active = false
    }
  }, [lang, live])

  return articles
}
